import {get, push, runTransaction, set, remove} from 'firebase/database'
import {currentUser, getRef} from "@/rtdb";
import {DBDirection, DBScans, DBTicket, ScanMode, ScanResult} from "@/@types";

export async function getTicket(eventId: string, ticketId: string): Promise<DBTicket | undefined> {
    if (!eventId || !ticketId) return undefined

    return (await get(getRef(`tickets/${eventId}/${ticketId}`))).val() as DBTicket

    // const scans = (await get(query(getRef(`scans/${eventId}/${ticketId}`), orderByKey(), limitToLast(99)))).val() as DBScans
    //
    // if (ticket)
    //     return {
    //         ...ticket,
    //         inside: !scans || (Object.values<DBScan>(scans)[0].direction === ScanMode.ENTER),
    //         scans
    //     }
    // else
    //     return undefined

}


export async function scansCount(eventId: string,) {
    return (await get(getRef(`scans/${eventId}`))).size
}

export async function deleteALLScans(eventId: string,) {
    await remove(getRef(`scans/${eventId}`))
}

export async function scan_(eventId: string, ticketId: string, mode: ScanMode): Promise<ScanResult | undefined> {

    // 1. Проверяем что билет есть в БД и не заблокирован

    const ticket = (await get(getRef(`tickets/${eventId}/${ticketId}`))).val() as DBTicket
    if (!ticket) {
        console.error('scanEnter2: нет билета в списке', ticketId)
        return undefined;
    } else if (ticket.blocked) {
        console.error('scanEnter2: билет заблокирован!', ticketId)
        return {
            blocked: true,
            committed: false, scans: {},
            lastScan: undefined,
            ticket: ticket
        };
    }

    // 2. Проверяем последние сканирования

    // проверяем что не было входов и записываем пометку входа
    const ticketRef = getRef(`scans/${eventId}/${ticketId}`)
    let ticketScans: DBScans | undefined = {}

    const currentData = (await get(ticketRef)).val() as DBScans | null

    let committed = false;

    // 3. Если сканируем вход или выход (не просто информация) тогда делаем транзакцию изменения последнего статуса


    async function scansAddNewScan(direction: DBDirection) {

        // Общий счетчик внутри людей и сколько пришло вообще
        // set(getRef(`scansTotal/${eventId}/inside`))


        // Генерируем ключ записи сканирования
        const scanRef = push(ticketRef)
        if (!scanRef.key) return undefined; // не получилось получтиь ключ почему то

        await set(scanRef, {
            direction: direction,
            timestamp: Date.now(),
            user: currentUser?.email
        })

        committed = true;

    }


    if (mode === ScanMode.ENTER || mode === ScanMode.EXIT) {


        console.log("data", currentData)
        //
        // if (currentData === null && mode === ScanMode.ENTER) {
        //     ticketScans = scansAddNewScan(ScanMode.ENTER)
        // }

        ticketScans = currentData ?? {}

        console.log(ticketScans, 'ticketScans')

        // получаем последнее сканирование
        const scansKeys = Object.keys(ticketScans)
        const lastScan = scansKeys.length > 0 ? ticketScans[scansKeys.sort()[scansKeys.length - 1]] : undefined;

        console.log(lastScan, 'lastScan')

        // Если Вход
        if (mode === ScanMode.ENTER) {
            if (lastScan === undefined || lastScan.direction === ScanMode.EXIT)
                await scansAddNewScan(ScanMode.ENTER)
        }
        // Если Выход
        else if (mode === ScanMode.EXIT) {
            if (lastScan !== undefined && lastScan.direction === ScanMode.ENTER)
                await scansAddNewScan(ScanMode.EXIT)
        }

    }

    // РЕжим инфо - просто читаем последние сканировки
    //else //{
        //ticketScans = (await get(ticketRef)).val() as DBScans ?? {}
    //}

    ticketScans = (await get(ticketRef)).val() as DBScans ?? {}

    const result = {
        ...ticket,
        committed: committed,
        ticket: ticket,
        scans: ticketScans,
        lastScan: ticketScans[Object.keys(ticketScans).sort()[Object.keys(ticketScans).length - 1]]
    }

    return result

}


export async function scan(eventId: string, ticketId: string, mode: ScanMode): Promise<ScanResult | undefined> {

    // 1. Проверяем что билет есть в БД и не заблокирован

    const ticket = (await get(getRef(`tickets/${eventId}/${ticketId}`))).val() as DBTicket
    if (!ticket) {
        console.error('scanEnter2: нет билета в списке', ticketId)
        return undefined;
    } else if (ticket.blocked) {
        console.error('scanEnter2: билет заблокирован!', ticketId)
        return {
            blocked: true,
            committed: false, scans: {},
            lastScan: undefined,
            ticket: ticket
        };
    }

    // 2. Проверяем последние сканирования

    // проверяем что не было входов и записываем пометку входа
    const ticketRef = getRef(`scans/${eventId}/${ticketId}`)
    let ticketScans: DBScans = {}

    const snapshot = await get(ticketRef)

    // 3. Если сканируем вход или выход (не просто информация) тогда делаем транзакцию изменения последнего статуса

    let transactionResult: Awaited<ReturnType<typeof runTransaction>> | undefined = undefined;
    //let retry = false;
    if (mode === ScanMode.ENTER || mode === ScanMode.EXIT) {

        transactionResult = await runTransaction(ticketRef, (currentData?: DBScans) => {

                // ВАЖНО - Функция внутри транзакции должна быть идемпотентной (без побочных эффектов), так как может выполняться несколько раз (до 25).
                // Отмена: Возврат undefined или null отменяет запись.

                console.log("data", currentData)

                if (currentData === null && mode === ScanMode.ENTER) {
                    return scansAddNewScan(ScanMode.ENTER)
                }


                function scansAddNewScan(direction: DBDirection) {

                    // Общий счетчик внутри людей и сколько пришло вообще
                    // set(getRef(`scansTotal/${eventId}/inside`))


                    // Генерируем ключ записи сканирования
                    const scanRef = push(ticketRef)
                    if (!scanRef.key) return undefined; // не получилось получтиь ключ почему то

                    ticketScans[scanRef.key] = {
                        direction: direction,
                        timestamp: Date.now(),
                        user: currentUser?.email
                    }

                    return ticketScans
                }

                ticketScans = currentData ?? {}

                console.log(ticketScans, 'ticketScans')

                // получаем последнее сканирование
                const scansKeys = Object.keys(ticketScans)
                const lastScan = scansKeys.length > 0 ? ticketScans[scansKeys.sort()[scansKeys.length - 1]] : undefined;

                console.log(lastScan, 'lastScan')

                // Если Вход
                if (mode === ScanMode.ENTER) {
                    if (lastScan === undefined || lastScan.direction === ScanMode.EXIT)
                        return scansAddNewScan(ScanMode.ENTER)
                }
                // Если Выход
                else if (mode === ScanMode.EXIT) {
                    if (lastScan !== undefined && lastScan.direction === ScanMode.ENTER)
                        return scansAddNewScan(ScanMode.EXIT)
                }

                return;

            }
        );
    }
    // РЕжим инфо - просто читаем последние сканировки
    else {
        ticketScans = (await get(ticketRef)).val() as DBScans ?? {}
    }

    const result = {
        ...ticket,
        committed: !!transactionResult?.committed,
        ticket: ticket,
        scans: ticketScans,
        lastScan: ticketScans[Object.keys(ticketScans).sort()[Object.keys(ticketScans).length - 1]]
    }

    return result

}

